// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1JpB5","email":"Footer_email__6IQCU","rights":"Footer_rights__2AlcG","credits":"Footer_credits__uh6K7"};